import React from "react";
import { LifecycleStageItem } from "../../screens/productSummary/components/LifecycleStageItem";
import { LifecycleStage } from "../../screens/productSummary/types";
import { Card, CardContent } from "../ui/common/card";

interface LifecycleStagesCardProps {
  stages: LifecycleStage[];
  expandedStage: string | null;
  onToggleStage: (label: string) => void;
  /** Bigger/bolder title + roomier padding for the tab-in-modal contexts (product/ingredient details). */
  compact?: boolean;
}

/**
 * Shared "Impact Breakdown" card — used by the Product Summary page and the
 * Product/Ingredient details modals' Environmental Footprint tabs. `compact`
 * switches to the modal tabs' bigger/bolder title and roomier padding versus
 * the Product Summary page's tighter default. Reuses the shared
 * `LifecycleStageItem` row renderer as-is.
 */
const LifecycleStagesCard: React.FC<LifecycleStagesCardProps> = ({
  stages,
  expandedStage,
  onToggleStage,
  compact
}) => {
  return (
    <Card className="lg:tw-col-span-6 tw-border-border tw-rounded-lg tw-pt-0">
      <CardContent className={compact ? "tw-p-2" : "tw-p-1"}>
        <div className="tw-border-b tw-border-primary/20 tw-pb-2.5 tw-mb-2">
          <p
            className={
              compact
                ? "tw-text-base tw-font-bold tw-text-primary tw-pl-1"
                : "tw-text-sm tw-font-semibold tw-text-primary tw-px-4 tw-py-2"
            }
          >
            Impact Breakdown
          </p>
        </div>
        <div className="tw-space-y-1">
          {stages.map(stage => (
            <LifecycleStageItem
              key={stage.label}
              stage={stage}
              isExpanded={expandedStage === stage.label}
              onToggle={() => onToggleStage(expandedStage === stage.label ? "" : stage.label)}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default LifecycleStagesCard;
